import { Loader } from "@screencloud/screencloud-ui-components";
import { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { StyledButton } from "./styles";

interface Props {
  isLoading: boolean;
  itemCount: number;
  onClick: () => void;
  loadMoreText?: string;
}

const LoadMoreButton: FunctionComponent<Props> = ({
  isLoading,
  itemCount,
  onClick,
  loadMoreText = "Load more",
}) => {
  const fetchMoreText = isLoading ? (
    <Loader inline active={true} size="small">
      <FormattedMessage id="common.text.loading" defaultMessage="Loading..." />
    </Loader>
  ) : (
    <FormattedMessage
      id="common.text.load_more_item_count"
      defaultMessage={`${loadMoreText} (${itemCount})`}
      values={{ itemCount, loadMoreText }}
    />
  );

  return (
    <StyledButton fullWidth disabled={isLoading} onClick={onClick}>
      {fetchMoreText}
    </StyledButton>
  );
};

export default LoadMoreButton;
